import { z } from "zod";

export const firstName = z
  .string()
  .min(2, { error: "First Name must be at least 2 characters" });
